
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19.9602 10.59C20.0002 10.28 19.7702 10 19.4602 10H17.0002V8.86C18.5402 8.46 19.7202 7.18 19.9602 5.59C20.0002 5.28 19.7702 5 19.4602 5H17.0002V4C17.0002 3.45 16.5502 3 16.0002 3H8.00017C7.45017 3 7.00017 3.45 7.00017 4V5H4.54017C4.23017 5 4.00017 5.28 4.04017 5.59C4.28017 7.18 5.46017 8.46 7.00017 8.86V10H4.54017C4.23017 10 4.00017 10.28 4.04017 10.59C4.28017 12.18 5.46017 13.46 7.00017 13.86V15H4.54017C4.23017 15 4.00017 15.28 4.04017 15.59C4.28017 17.18 5.46017 18.46 7.00017 18.86V20C7.00017 20.55 7.45017 21 8.00017 21H16.0002C16.5502 21 17.0002 20.55 17.0002 20V18.86C18.5402 18.46 19.7202 17.18 19.9602 15.59C20.0002 15.28 19.7702 15 19.4602 15H17.0002V13.86C18.5402 13.46 19.7202 12.18 19.9602 10.59ZM12.0002 19C10.8902 19 10.0002 18.1 10.0002 17C10.0002 15.9 10.8902 15 12.0002 15C13.1002 15 14.0002 15.9 14.0002 17C14.0002 18.1 13.1102 19 12.0002 19ZM12.0002 14C10.8902 14 10.0002 13.1 10.0002 12C10.0002 10.9 10.8902 10 12.0002 10C13.1002 10 14.0002 10.9 14.0002 12C14.0002 13.1 13.1102 14 12.0002 14ZM12.0002 9C10.8902 9 10.0002 8.1 10.0002 7C10.0002 5.89 10.8902 5 12.0002 5C13.1002 5 14.0002 5.89 14.0002 7C14.0002 8.1 13.1102 9 12.0002 9Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-traffic`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTraffic

    ```js
    <b-new-b-icon-traffic />
    ```
</docs>


